<template>
  <div
    class="block items-center border border-r-0 border-solid border-border bg-gray-100 px-2.5 py-1.5 text-gray-500 first:rounded-l-md first:border-l sm:text-sm dark:bg-card dark:text-muted-foreground"
  >
    <slot></slot>
  </div>
</template>

<script lang="ts" setup></script>
